<template>
  <div class="homeData"
       v-if="bdis">
    <div class="analysis_wrapper" v-if="!hideIndexBarData">
      <div class="analysis"
           @click="linkDetail">
        <div class="logo_a">
          <i class="iconfont icon-transaction_fill"></i>
        </div>
        <div class="analy clearfix">
          <div class="analy_t firstAnaly"
               style="">
            <!-- 预计本日总营收 -->
            <p class="p1">{{$t('index_homeData_title')}} </p>
            <p class="p2"
               v-html="$formatMoney(homeInfo.revenue,homeInfo.dis,true,'￥')">
            </p>
          </div>
          <div class="analy_t">
            <!--  可售 -->
            <p class="p1">{{$t('index_homeData_analy')}} </p>
            <p class="p2">{{homeInfo.avl}}
              <small>{{$t('index_homeData_analy_unit')}}</small>
            </p>
          </div>
        </div>
        <div class="analysis_bottom clearfix">
          <div class="analy_t">
            <!--  过夜出租率 -->
            <p class="p1">{{$t('index_homeData_analysis')}}</p>
            <p class="p2">{{homeInfo.rentRate}}
              <small>%</small>
            </p>
          </div>
          <div class="analy_t line">
            <span class="line_l"></span>
            <!--  过夜均价 -->
            <p class="p1">{{$t('index_homeData_analysis_avg')}} </p>
            <p class="p2">
              <small>￥</small>
              {{homeInfo.avgPrice}}
            </p>
            <span class="line_r"></span>
          </div>
          <div class="analy_t">
            <p class="p1">REVPAR</p>
            <p class="p2">
              <small>￥</small>
              {{homeInfo.revPar}}
            </p>
          </div>
        </div>
        <div class="more" v-if="mhDbRevenDe"><i class="iconfont icon-you1"></i></div>
      </div>
    </div>

    <div id="angle"
         class="angle"></div>


    <div class="chartbottom clearfix">
      <div class="allNum">
        <div style="font-size: 15px;">{{$t('index_homeData_angle_allNum')}}</div>
        <div style="font-size: 22px;">{{homeInfo.ttl}}</div>
        <div style="font-size: 15px;"> {{$t('index_homeData_angle_allNum_unit')}}</div>
      </div>
      <div style="float: right; width: 55%">
        <div>
          <div class="lenged" style="width: 50%">
            <div class="lengedTop">
              <div class="lengedcolor"
                   style="background-color: #03c9cc"></div>
              <!-- 可售房 -->
              <p>{{$t('index_homeData_angle_sort')}} </p>
            </div>
            <p class="num">{{homeInfo.avl}}</p>
          </div>
          <div class="lenged" style="width: 50%">
            <div class="lengedTop">
              <div class="lengedcolor"
                   style="background-color: #ffa500"></div>
              <!-- 占用房 -->
              <p> {{$t('index_homeData_angle_takeUp')}} </p>
            </div>
            <p class="num">{{homeInfo.rentAmount}}</p>
          </div>
        </div>
        <div>
          <div class="lenged" style="width: 50%">
            <div class="lengedTop">
              <div class="lengedcolor"
                   style="background-color: #e7737e"></div>
              <!-- 维修房 -->
              <p> {{$t('index_homeData_angle_maintenance')}}</p>
            </div>
            <p class="num">{{homeInfo.ooo}}</p>
          </div>
          <div class="lenged" style="width: 50%">
            <div class="lengedTop">
              <div class="lengedcolor"
                   style="background-color: #ba9fe2"></div>
              <!-- 自用房 -->
              <p>{{$t('index_homeData_angle_personalUse')}}</p>
            </div>
            <p class="num">{{homeInfo.hse}}</p>
          </div>
        </div>
        <div>
          <div class="lenged" style="width: 50%">
            <div class="lengedTop">
              <div class="lengedcolor"
                   style="background-color: #2fb3f4"></div>
              <!-- 免费房 -->
              <p>{{$t('index_homeData_angle_free')}}</p>
            </div>
            <p class="num">{{homeInfo.com}}</p>
          </div>
<!--          <div class="lenged" style="width: 50%">-->
<!--            <div class="lengedTop">-->
<!--              <div class="lengedcolor"-->
<!--                   style="background-color: #8a98b5"></div>-->
<!--              &lt;!&ndash; 锁定房 &ndash;&gt;-->
<!--              <p>{{$t('index_homeData_angle_lock')}}</p>-->
<!--            </div>-->
<!--            <p class="num">{{homeInfo.oos}}</p>-->
<!--          </div>-->
        </div>
      </div>
    </div>

    <div class='chartbottom clearfix'
         v-if='homeInfo.singleHotel'
         style='border-top: 1px solid #eaeaea;padding-top: 15px;'>
      <!--fuck-->
      <div class="lenged">
        <div class="lengedTop"
             style='text-align: center;'>
          <!-- 本日将到 -->
          {{$t('index_homeData_notarrRoom')}}
        </div>
        <p class="num">{{homeInfo.notarrRoom}}</p>
      </div>

      <div class="lenged">
        <div class="lengedTop"
             style='text-align: center;'>
          <!-- 本日已到 -->
          {{$t('index_homeData_isarrRoom')}}
        </div>
        <p class="num">{{homeInfo.isarrRoom}}</p>
      </div>

      <div class="lenged">
        <div class="lengedTop"
             style='text-align: center;'>
          <!-- 本日未离 -->
          {{$t('index_homeData_notdepRoom')}}
        </div>
        <p class="num">{{homeInfo.notdepRoom}}</p>
      </div>

      <div class="lenged">
        <div class="lengedTop"
             style='text-align: center;'>
          <!-- 本日已离 -->
          {{$t('index_homeData_isdepRoom')}}
        </div>
        <p class="num">{{homeInfo.isdepRoom}}</p>
      </div>
    </div>

    <div class='chartbottom clearfix'>
      <div class="tipBar">
        <!-- 指标定义 -->
        <router-link :to="'/indexDesc'"><i class="iconfont icon-gantan"></i> {{$t('index_homeData_define')}}
        </router-link>
      </div>
      <div class="dx">
        　<span>{{$t('loading_end_message')}} </span>　
      </div>
    </div>
  </div>
</template>
<script>
  import echarts from "echarts";
  import {Toast, MessageBox} from "mint-ui";

  export default {
    props: {},
    data() {
      return {
        bdis: false,
        homeInfo: "",
        mhDbRevenDe: false,
        hideIndexBarData: localStorage.getItem('hideIndexBarData') == 'yes',
      };
    },
    mounted() {
      this.mhDbRevenDe = this.$hasPermission('mh!db!reven!de', true)
    },
    methods: {
      getData() {
        this.bdis = true;
        setTimeout(() => {
          this.disData();
        }, 10);
      },
      disData() {
        var echartFs = lib.flexible.rem2px([0.3]);
        var angle = document.getElementById("angle")
        if(!angle){
          return
        }
        document.getElementById("angle").style.width = window.innerWidth + "px";
        var myChart = echarts.init(document.getElementById("angle"), "customed");
        // 绘制图表
        this.$http.post("/mobilepmsapi/sys/homeInfo").then(res => {
          if (res.data.result == 0) {
            this.homeInfo = res.data.retVal;
            if (this.homeInfo.msg) {
              this.msg(this.homeInfo.msg);
            }
            var data = [
              {
                value: res.data.retVal.ooo,
                name: this.$t('index_homeData_angle_maintenance'),
                itemStyle: {normal: {color: "#e7737e"}}
              },
              {
                value: res.data.retVal.rentAmount,
                name: this.$t('index_homeData_angle_takeUp'),
                itemStyle: {normal: {color: "#f69c2c"}}
              },
              {
                value: res.data.retVal.avl,
                name: this.$t('index_homeData_angle_sort'),
                itemStyle: {normal: {color: "#03c9cc"}}
              },
              {
                value: res.data.retVal.hse,
                name: this.$t('index_homeData_angle_personalUse'),
                itemStyle: {normal: {color: "#ba9fe2"}}
              },
              {
                value: res.data.retVal.com,
                name: this.$t('index_homeData_angle_free'),
                itemStyle: {normal: {color: "#2fb3f4"}}
              },
            ];
            var suodingData =  {
              value: res.data.retVal.oos,
              name: this.$t('index_homeData_angle_lock'),
              itemStyle: {normal: {color: "#8a98b5"}}
            }

            for (var i = data.length - 1; i >= 0; i--) {
              if (data[i].value <= 0) {
                data.splice(i, 1);
              } else {
                // 锁定房并入到可售房
                if(data[i].name == this.$t('index_homeData_angle_sort')){
                  data[i].name += ":" + data[i].value
                  if(suodingData.value > 0){
                    data[i].name += '\n(' + suodingData.name + ":" +  suodingData.value + ')'
                  }
                } else {
                  data[i].name += ":" + data[i].value;
                }
              }
            }
            var option = {
              // color:['#e7737e','#8a98b5','#03c9cc','#ba9fe2','#2fb3f4','#ffb576'],
              series: [
                {
                  name: this.$t('orderFromReport_chart_series_name'),
                  type: "pie",
                  radius: "70%",
                  center: ["50%", "50%"],
                  //roseType: "angle",
                  data: data,
                  itemStyle: {
                    normal: {
                      label: {
                        textStyle: {
                          fontSize: echartFs
                        }
                      }
                    }
                  }
                }
              ]
            };
            myChart.setOption(option);
          } else {
            this.msg(res.data.msg);
          }
        });
      },
      linkDetail() {
        if (this.mhDbRevenDe) {
          return this.$router.push("indexDetail");
        }
      },
      msg(msg) {
        Toast({message: msg, position: "bottom", duration: 3000});
      }
    },
    filters: {
      formatW(value) {
        return (value / 10000).toFixed(2);
      },
      formatK(value) {
        return (value / 1000).toFixed(2);
      }
    }
  };
</script>
<style lang='less'>
  .homeData {
    padding-bottom: 1.5rem;

    .angle {
      height: 7rem;
      width: 10rem;
      margin-top: 0.3rem;
      background: #fff;
      display: inline-block;
    }

    .analysis {
      background: #f6f8f9;
      width: 100%;
      position: relative;
      top: -1px;
      box-sizing: border-box;
      padding: 0.3rem 0.13333333rem 0 0;
      background-image: linear-gradient(to top, #ff6e61, #ffa500);

      .more {
        position: absolute;
        right: 5px;
        top: 1.7rem;
        color: #fff;

        i {
          font-size: 0.7rem;
        }
      }

      .logo_a {
        width: 2.34666667rem;
        float: left;
        text-align: center;
        line-height: 1.86666667rem;
        height: 1.86666667rem;

        .iconfont {
          font-size: 1.33333333rem;
          color: #fff;
        }
      }

      .analy {
        .firstAnaly {
          width: 4.13333333rem;
          float: left;
          text-align: left;
        }
      }

      .analy_t {
        float: left;
        width: 33%;
        text-align: center;
        color: #fff;
        height: 50%;
        font-family: PingFangSC-Regular;

        .p1 {
          margin: 0 auto;
          margin-top: 0.26666667rem;
          height: 0.4rem;
          line-height: 0.4rem;
          font-size: 0.32rem;
          position: relative;

          width: ~"calc(100% - 4px)";
        }

        .p2 {
          margin: 0 auto;
          font-size: 0.64rem;
          line-height: 1.06666667rem;
          height: 1.2rem;
          position: relative;

          width: ~"calc(100% - 2px)";
          margin: 0 auto;

          small {
            vertical-align: baseline;
            font-size: 0.32rem;
            -webkit-transform-origin-x: 0;
            -webkit-transform: scale(0.6);
          }
        }

        &.line {
          position: relative;

          .line_l {
            position: absolute;
            width: 1px;
            height: 0.58666667rem;
            background: #fff;
            left: 0;
            top: 0.66666667rem;
            z-index: 1;
          }

          .line_r {
            position: absolute;
            width: 1px;
            height: 0.58666667rem;
            right: 0;
            top: 0.66666667rem;
            background: #fff;
            z-index: 1;
          }
        }
      }
    }

    .chartbottom {
      padding: 0 0.4rem;
      margin-bottom: 0.28rem;
      position: relative;

      .allNum {
        width: 3.5rem;
        border-radius: 0.45333333rem;
        float: left;
        padding-top: 10px;
        padding-bottom: 10px;
        margin-top: 10px;
        background-color: #ededed;
        line-height: 36px;
        font-size: 0.36rem;
        text-align: center;
        margin-right: 0.58666667rem;
      }

      .lenged {
        float: left;
        width: 25%;
        height: 1.33333333rem;
        padding: 0.13333333rem 0;

        .lengedTop {
          height: 0.53333333rem;
          line-height: 0.53333333rem;

          .lengedcolor {
            width: 0.53333333rem;
            height: 0.26666667rem;
            margin-top: 0.13333333rem;
            border-radius: 0.08rem;
            margin-left: 0.13333333rem;
            float: left;
          }

          p {
            margin-left: 0.16rem;
            float: left;
            text-align: left;
          }
        }

        .num {
          text-align: center;
          font-size: 0.48rem;
          line-height: 0.8rem;
        }
      }
    }

    .analysis_wrapper {
      padding: 10px 0;
      background-color: #f6f8f9;
    }

    .tipBar {
      padding: 10px 0 0;
      clear: both;
      font-size: 0.32rem;
      text-align: right;
    }

    .tipBar a {
      color: #b2c1cc;
    }

    .dx {
      padding-bottom: 10px;
      text-align: center;
      height: 20px;
      margin-top: 20px;
      line-height: 20px;
      color: #eee;

      span {
        color: #ddd;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// homeData.vue?aa150cf4